import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useField } from "formik";
import React from "react";
import { Avatar } from "../../../commons/Avatar.js";
import { Attachment } from "../../attachments/helpers.js";

interface Props {
  name: string;
  organisationTitle: string;
  importing: boolean;
  disabled?: boolean;
}

export const OnboardingFlowLogoField = ({
  name,
  organisationTitle,
  importing,
  disabled = false,
}: Props) => {
  const { t } = useTranslate("OrganisationProfile");
  const [{ value }, , { setValue }] = useField<Attachment | null>(name);

  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
      <Box sx={{ position: "relative" }}>
        {/* The avatar is a small square thumbnail; clicking it opens the
            upload modal, which shows the original file at full modal width. */}
        <Avatar
          url={value?.url}
          initials={organisationTitle.substring(0, 2)}
          size="l"
          disabled={disabled || importing}
          onAttachment={async attachment => {
            await setValue(attachment);
          }}
          uploadModalProps={{
            title: t("Edit public profile picture"),
            initialTitle: t("Public profile picture"),
          }}
        />
        {importing && (
          <CircularProgress
            size={24}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Box>
      <Typography variant="body2">{t("Company logo")}</Typography>
    </Stack>
  );
};
